// extracted by mini-css-extract-plugin
export default {"accumulator":"Dv3MR","disabled":"qJOX9","value":"We6nQ","icon":"Y2RdG","label":"fDSF5","inline":"DXtHH","component":"dIbJ2"};